import { isDevMode, NgModule } from '@angular/core';
import { StoreModule as NGRXStoreModule } from '@ngrx/store';
import { metaReducers } from '@store/local-store-sync.config';
import { LocationsEffects } from './features/location-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { rootReducers } from './root-store';

@NgModule({
  imports: [
    EffectsModule.forRoot([LocationsEffects]),
    NGRXStoreModule.forRoot(rootReducers, { metaReducers, runtimeChecks: { strictStateImmutability: false } }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
  ],
})
export class StoreModule {}
